<div class="block--content m-0 block min-h-full">
    <div class="mx-auto mb-4 flex max-w-screen-xl flex-col gap-4 md:flex-row md:items-start md:p-4 md:px-20">
        <!-- Left Panel: Search and Segment -->
        <div class="bg-white shadow-sm md:w-96 md:rounded-md">
            <div class="grid h-16 grid-cols-[3rem_1fr_3rem]">
                <button class="p-0" [attr.aria-label]="'LOCAL_BTN_BACK' | translate" (click)="handleBackClicked()">
                    <mat-icon class="material-icons-outlined text-2xl dark:filter-yellow md:invisible">
                        arrow_back
                    </mat-icon>
                </button>
                <h1 class="flex items-center justify-center text-base font-bold">
                    {{ 'ADD_NOTIFICATIONS_SIDE_TITLE' | translate }}
                </h1>
            </div>
            <div class="flex flex-col gap-3 px-3 pb-3">
                <ion-searchbar
                    class="rounded-md text-black dark:bg-contrast-yellow"
                    id="explore-search"
                    [placeholder]="'EXPLORE_SEARCH_PLACEHOLDER' | translate"
                    [formControl]="searchControl"
                    (ionFocus)="showSearch()"
                    show-clear-button="never"
                    mode="ios"></ion-searchbar>
                <ion-segment [value]="segment" (ionChange)="tabChange($event)" mode="ios">
                    <ion-segment-button value="routeGroups">
                        <ion-label class="p-2 font-bold dark:text-contrast-black">{{ 'ROUTES' | translate }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button *ngIf="showStopsTab">
                        <ion-label class="p-3 font-bold dark:text-contrast-black">{{
                            'SCHEDULE_STOPS_LAYER' | translate
                        }}</ion-label>
                    </ion-segment-button>
                </ion-segment>
                <div>{{ 'NOTIFICATIONS_EXTENT_NOTICE' | translate }}</div>
            </div>
        </div>

        <div class="flex flex-1 flex-col bg-white shadow-sm md:rounded-md" [ngSwitch]="segment">
            <div class="list-content order-3 flex-1 overflow-y-auto md:order-1">
                <!-- Route Groups -->
                <div *ngSwitchCase="'routeGroups'">
                    <ion-list mode="ios" lines="full">
                        <ion-item *ngFor="let group of routesGroups$ | async" (click)="showRoutes(group)" button>
                            <ion-label class="py-2">{{ group.name | translate }}</ion-label>
                        </ion-item>
                    </ion-list>
                </div>

                <!-- Stops -->
                <div *ngSwitchCase="'stops'">
                    <ion-list *ngIf="showStopsTab" mode="ios" lines="full">
                        <ion-item *ngFor="let stop of (stops$ | async).slice(0, 20)">
                            <ion-checkbox
                                [checked]="(stopSubscriptions$ | async).has(stop.id) || isStopSelected(stop)"
                                [disabled]="
                                    (stopSubscriptions$ | async).has(stop.id) ||
                                    (selectedStops.length >= selectionLimit && !isStopSelected(stop))
                                "
                                (ionChange)="toggleStopSubscription($event, stop)"
                                color="secondary"
                                mode="md"
                                slot="start">
                            </ion-checkbox>
                            <ion-label class="py-2">
                                {{ stop.name }}
                                <div class="text-xs font-medium leading-4 text-grey-zambezy dark:text-contrast-yellow">
                                    {{ stop.desc }}
                                </div>
                            </ion-label>
                        </ion-item>
                    </ion-list>
                </div>

                <!-- Routes -->
                <div *ngSwitchCase="'routes'">
                    <ion-list mode="ios" lines="full">
                        <ion-item *ngFor="let route of routes$ | async">
                            <ion-checkbox
                                [checked]="(routeSubscriptions$ | async).has(route.id) || isRouteSelected(route)"
                                [disabled]="
                                    (routeSubscriptions$ | async).has(route.id) ||
                                    (selectedRoutes.length >= selectionLimit && !isRouteSelected(route))
                                "
                                (ionChange)="toggleRouteSubscription($event, route)"
                                color="secondary"
                                mode="md"
                                slot="start">
                            </ion-checkbox>
                            <ion-label class="py-2">
                                <div class="flex items-center gap-2">
                                    <rwidget-route-short-name
                                        [label]="route.shortName"
                                        [color]="route.icon?.color || 'var(--color-secondary)'"
                                        [shape]="route.icon?.shape || ShapeType.ROUNDED"
                                        size="md">
                                    </rwidget-route-short-name>
                                    {{ route.longName }}
                                </div>
                            </ion-label>
                        </ion-item>
                    </ion-list>
                </div>

                <!-- Search Results -->
                <div *ngSwitchCase="'search'">
                    <ion-list mode="ios" lines="full">
                        <div class="flex justify-center py-2" *ngIf="isSearching$ | async">
                            <ridango-ui-basic-loading-spinner ariaLabel="SEARCHING_ROUTES_AND_STOPS">
                            </ridango-ui-basic-loading-spinner>
                        </div>

                        <ion-item *ngIf="noResults$ | async">
                            <ion-label class="py-4 text-center text-grey-zambezy dark:text-contrast-yellow">
                                {{ 'ADD_SUBSCRIPTIONS_NO_SEARCH_RESULTS' | translate }}
                            </ion-label>
                        </ion-item>

                        <!-- Search Stops -->
                        <ng-container>
                            <ion-item *ngFor="let stop of searchStops$ | async">
                                <ion-checkbox
                                    [checked]="(stopSubscriptions$ | async).has(stop.id) || isStopSelected(stop)"
                                    [disabled]="
                                        (stopSubscriptions$ | async).has(stop.id) ||
                                        (selectedStops.length + selectedRoutes.length >= selectionLimit &&
                                            !isStopSelected(stop))
                                    "
                                    (ionChange)="toggleStopSubscription($event, stop)"
                                    color="secondary"
                                    mode="md"
                                    slot="start">
                                </ion-checkbox>
                                <ion-label class="py-2">
                                    <div class="flex items-center gap-2">
                                        <ion-icon
                                            class="hu-light:text-black h-[1.6rem] w-[1.6rem] rounded text-white dark:filter-yellow"
                                            [src]="(assetsPath$ | async) + '/img/explore/bus.svg'"
                                            [attr.aria-label]="'STOP' | translate">
                                        </ion-icon>
                                        <div>
                                            {{ stop.name }}
                                            <div
                                                class="text-xs font-medium leading-4 text-grey-zambezy dark:text-contrast-yellow">
                                                {{ stop.desc }}
                                            </div>
                                        </div>
                                    </div>
                                </ion-label>
                            </ion-item>
                        </ng-container>

                        <!-- Search Routes -->
                        <ion-item *ngFor="let route of searchRoutes$ | async">
                            <ion-checkbox
                                [checked]="(routeSubscriptions$ | async).has(route.id) || isRouteSelected(route)"
                                [disabled]="
                                    (routeSubscriptions$ | async).has(route.id) ||
                                    (selectedStops.length + selectedRoutes.length >= selectionLimit &&
                                        !isRouteSelected(route))
                                "
                                (ionChange)="toggleRouteSubscription($event, route)"
                                color="secondary"
                                mode="md"
                                slot="start">
                            </ion-checkbox>
                            <ion-label class="py-2">
                                <div class="flex items-center gap-2">
                                    <rwidget-route-short-name
                                        [label]="route.shortName"
                                        [color]="route.icon?.color || 'var(--color-secondary)'"
                                        [shape]="route.icon?.shape || ShapeType.ROUNDED"
                                        size="md">
                                    </rwidget-route-short-name>
                                    {{ route.longName }}
                                </div>
                            </ion-label>
                        </ion-item>
                    </ion-list>

                    <div class="px-10 pb-2 text-center" *ngIf="hasMoreResults$ | async">
                        <button
                            class="py-4 text-base font-semibold leading-5 text-primary dark:text-contrast-yellow"
                            [attr.aria-label]="'SHOW_MORE_LOCATIONS' | translate"
                            (click)="loadMoreSearchResults()"
                            tabindex="0">
                            {{ 'SHOW_MORE_LOCATIONS' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <div
                class="list-footer order-1 mb-5 flex h-[100px] shrink-0 items-center bg-white px-5 shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1)] dark:bg-contrast-black md:order-2 md:mb-0 md:mt-5 md:shadow-[0px_-4px_6px_-1px_rgba(0,0,0,0.1)]"
                *ngIf="segment !== 'routeGroups' && (selectedRoutes.length > 0 || selectedStops.length > 0)">
                <ion-button
                    class="dark:border-contrast-yellow"
                    [attr.aria-label]="'CHOOSE' | translate"
                    (click)="getAllSelectedRouteStops()"
                    size="large"
                    color="secondary">
                    <ion-label class="whitespace-normal text-sm font-bold normal-case">
                        {{ 'CHOOSE' | translate }}
                    </ion-label>
                </ion-button>
            </div>
        </div>
    </div>
</div>
